const reg = {
	email:
		/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/,
	phone: /^[1]([3-9])[0-9]{9}$/,
	qdRegexString: /^[a-zA-Z0-9_-]+$/,
	regBuyerTaxNo: /^[0-9a-zA-Z]{7,20}$/,
};
